import { FC } from "react";
import MultiStockCardVertical from "./MultiStockCardVertical";
import MultiStockCardHorizontal from "./MultiStockCardHorizontal";
import Skeleton from "react-loading-skeleton";
import type { MoodEnum } from "data/enums";


interface MultiStockCardProps {
    id: string | number;
    className?: string;
    cover: string;
    images?: string[];
    title: string;
    mood?: MoodEnum;
    annotation?: string;
    description?: string;
    address?: string;
    price?: number;
    salePrice?: number;
    rating?: number;
    reviewCount?: number;
    max_guests?: number;
    minutes_duration?: number;
    isLiked?: boolean;
    onClickLike?: (e: any) => void;
    orientation?: "horizontal" | "vertical";
    href?: string;
    loading?: boolean;
    draggable?: boolean;
    onDragStart?: (e: any) => void;
    onDragEnd?: (e: any) => void;
    children?: React.ReactNode | React.ReactNode[];
    in_review?: boolean;
    stopped?: boolean;
    showStatusBadge?: boolean;
}

const MultiStockCard: FC<MultiStockCardProps> = ({
    id,
    className = "",
    cover,
    images = [],
    title,
    mood = null,
    description,
    annotation = null,
    address,
    price = null,
    salePrice = null,
    rating = null,
    reviewCount = null,
    max_guests = null,
    minutes_duration = null,
    isLiked = false,
    onClickLike,
    href,
    orientation = "vertical",
    draggable = false,
    onDragStart = () => { },
    onDragEnd = () => { },
    loading = false,
    children,
    in_review = false,
    stopped = false,
    showStatusBadge = false,
}) => {
    switch (orientation) {
        case "horizontal":
            if (!loading) {
                return (
                    <MultiStockCardHorizontal
                        id={id}
                        className={className}
                        cover={cover}
                        images={images}
                        annotation={annotation}
                        title={title}
                        mood={mood}
                        description={description ? description.slice(0, 100)+"..." : ""}
                        address={address}
                        price={price}
                        salePrice={salePrice}
                        rating={rating}
                        reviewCount={reviewCount}
                        max_guests={max_guests}
                        minutes_duration={minutes_duration}
                        isLiked={isLiked}
                        onClickLike={onClickLike}
                        href={href}
                        draggable={draggable}
                        onDragStart={onDragStart}
                        onDragEnd={onDragEnd}
                        in_review={in_review}
                        stopped={stopped}
                        showStatusBadge={showStatusBadge}
                    >
                        {children}
                    </MultiStockCardHorizontal>
                );
            } else {
                return <Skeleton height={300} />;
            }
        case "vertical":
        default:
            if (!loading) {
                return (
                    <MultiStockCardVertical
                        id={id}
                        className={className}
                        cover={cover}
                        annotation={annotation}
                        images={images}
                        title={title}
                        mood={mood}
                        description={description ? description.slice(0, 100)+"..." : ""}
                        address={address}
                        price={price}
                        salePrice={salePrice}
                        rating={rating}
                        reviewCount={reviewCount}
                        max_guests={max_guests}
                        minutes_duration={minutes_duration}
                        isLiked={isLiked}
                        onClickLike={onClickLike}
                        href={href}
                        draggable={draggable}
                        onDragStart={onDragStart}
                        onDragEnd={onDragEnd}
                        in_review={in_review}
                        stopped={stopped}
                        showStatusBadge={showStatusBadge}
                    >
                        {children}
                    </MultiStockCardVertical>
                );
            } else {
                return <Skeleton height={300} />;
            }
    }
};

export default MultiStockCard;